<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position:relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <TableFilters v-model="filterOptions" style="margin-right: 45px" @click="refresh" />
            <DropdownColumns v-model="fields" class="customize" />
          </div>
          <div style="overflow:auto">
            <b-table
              id="user-activity-table"
              :busy.sync="isBusy"
              show-empty
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :hover="true"
              :striped="true"
              stacked="md"
              v-model="copy"
              :items="provider"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              @row-clicked="rowClicked"
              tbody-tr-class="tr-pointer"
              v-columns-resizable="{afterResize: columnsWidthChanged}"
            >
              <template v-slot:empty="scope">
                <div class="text-center">{{ $t(scope.emptyText) }}</div>
              </template>

              <template v-slot:head(online)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(username)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(etenant_id)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(eshop_id)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(eterminal_id)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(session)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(ip)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(connected_at)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(disconnected_at)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(duration)="data">{{ $t(data.label) }}</template>

              <template v-slot:cell(online)="data">
                <span v-if="data.item.disconnected_at == 0" class="text-success">{{$t("ONLINE")}}</span>
                <span v-else class="text-danger">{{$t("OFFLINE")}}</span>
              </template>

              <template v-slot:cell(duration)="data">
                <span>{{duration(data.item.connected_at, data.item.disconnected_at)}}</span>
              </template>

              <template v-slot:cell(username)="data">
                <router-link
                  :to="`/users/${data.item.euser_id}`"
                  v-if="data.item.euser_id"
                >{{data.item.username ? data.item.username : data.item.euser_id}}</router-link>
              </template>

              <template v-slot:cell(etenant_id)="data">
                <span v-if="data.value.to">
                  <router-link :to="`/tenants/${data.value.to}`">{{ data.value.name }}</router-link>
                </span>
                <span v-else>{{ data.value.name }}</span>
              </template>

              <template v-slot:cell(eshop_id)="data">
                <span v-if="data.value.to">
                  <router-link :to="`/shops/${data.value.to}`">{{ data.value.name }}</router-link>
                </span>
                <span v-else>{{ data.value.name }}</span>
              </template>

              <template v-slot:cell(eterminal_id)="data">
                <span v-if="data.value.to">
                  <router-link :to="`/shops/${data.value.to}`">{{ data.value.name }}</router-link>
                </span>
                <span v-else>{{ data.value.name }}</span>
              </template>

              <template v-slot:cell(connected_at)="data">
                <span>{{ mom_unix(data.value).format(tableDateLong) }}</span>
              </template>
              <template v-slot:cell(disconnected_at)="data">
                <span v-if="data.value != 0">{{ mom_unix(data.value).format(tableDateLong) }}</span>
                <span v-else>{{$t("IN PROGRESS")}}</span>
              </template>
            </b-table>
          </div>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space:nowrap;" class="my-2">
                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{(currentPage-1) * perPage + 1}}</span>
                    <span slot="end">{{currentPage * perPage}}</span>
                    <span slot="total">{{totalRows}}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="$root.$emit('bv::refresh::table', 'user-activity-table')"
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import startCase from "@/shared/strings";
import { errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import TableFilters from "@/components/TableFilters";

export default {
  name: "user-activity",
  mixins: [tableMixin],
  components: {
    PaginationSelect,
    DropdownColumns,
    TableFilters
  },
  data: function() {
    return {
      tableName: "user-activity",
      filterOptions: [
        {
          field: "company_id",
          multiple: true,
          placeholder: "Company",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "companies",
          hide_select: true,
          filterOptions: ["tenant_id"],
          options: [],
          selected: [],
          postIgnore: true
        },
        {
          field: "tenant_id",
          multiple: true,
          placeholder: "Tenant",
          trackBy: "eid",
          label: "brand_name",
          translate: false,
          store: "tenants",
          hide_select: true,
          filterOptions: ["shopgroup_id", "shop_id"],
          options: [],
          originalOptions: [],
          selected: [],
          postIgnore: false,
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map(elem => elem.eid);
            const orig = data.list[1].originalOptions;
            if (
              selected.length == 0 &&
              data.list[1].options.length != orig.length
            ) {
              data.list[1].options = orig;
            } else if (selected.length != 0) {
              data.list[1].options = orig.filter(item => {
                if (selected.indexOf(item.ecompany_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          }
        },

        {
          field: "shopgroup_id",
          multiple: true,
          placeholder: "Shop Group",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shopGroups",
          hide_select: true,
          options: [],
          originalOptions: [],
          selected: [],
          filterOptions: ["shop_id"],
          postIgnore: true,
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map(elem => elem.eid);
            const index = 2;
            const orig = data.list[index].originalOptions;
            if (selected.length == 0) {
              data.list[index].options = orig;
            } else {
              data.list[index].options = orig.filter(item => {
                if (selected.indexOf(item.etenant_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          }
        },
        {
          field: "shop_id",
          multiple: false,
          placeholder: "Shop",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shops",
          hide_select: true,
          options: [],
          originalOptions: [],
          selected: [],
          postIgnore: false,
          filterOptionsBy: (data, field, fieldValue) => {
            let selectedTenants = [];
            let selectedShopGroups = [];

            if (field == "tenant_id") {
              selectedTenants = fieldValue.map(elem => elem.eid);
            } else {
              selectedTenants = data.list[0].selected.map(elem => elem.eid);
            }
            if (field == "shopgroup_id") {
              selectedShopGroups = fieldValue.map(elem => elem.eshop_ids);
              if (selectedShopGroups.length) {
                selectedShopGroups = [].concat.apply([], selectedShopGroups);
              }
            } else {
              selectedShopGroups = data.list[2].selected.map(
                elem => elem.eshop_ids
              );
              if (selectedShopGroups.length) {
                selectedShopGroups = [].concat.apply([], selectedShopGroups);
              }
            }
            const index = 3;
            const orig = data.list[index].originalOptions;

            if (!selectedTenants.length && !selectedShopGroups.length) {
              data.list[index].options = orig;
            } else {
              let tmp = [];

              if (selectedTenants.length) {
                tmp = orig.filter(item => {
                  if (selectedTenants.indexOf(item.etenant_id) > -1) {
                    return true;
                  }
                  return false;
                });
              }

              if (selectedShopGroups.length) {
                if (!selectedTenants.length && !selectedTenants.length) {
                  tmp = orig;
                }
                tmp = tmp.filter(item => {
                  if (selectedShopGroups.indexOf(item.eid) > -1) {
                    return true;
                  }
                  return false;
                });
              }
              data.list[index].options = tmp;
            }
          }
        },
        {
          field: "terminal_id",
          multiple: false,
          placeholder: "Type",
          postIgnore: false,
          options: [
            { name: "Terminal", value: "1" },
            { name: "Browser", value: "2" }
          ],
          selected: []
        },
        {
          field: "disconnected_at",
          multiple: false,
          placeholder: "User Status",
          postIgnore: false,
          options: [
            { name: "Online", value: 0 },
            { name: "Offline", value: 1 }
          ],
          selected: []
        },
        {
          field: "connected_at",
          type: "date",
          opens: "right",
          selected: {
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day")
          },
          default: {
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day")
          },
          ranges: {
            "Last hour": [moment().subtract(1, "hour"), moment()],
            "Last 6 hours": [moment().subtract(6, "hours"), moment()],
            "Last 24 hours": [moment().subtract(24, "hours"), moment()],
            Today: [moment().startOf("day"), moment().endOf("day")],
            Yesterday: [
              moment()
                .subtract(1, "days")
                .startOf("day"),
              moment()
                .subtract(1, "days")
                .endOf("day")
            ],
            "This week": [
              moment().startOf("isoWeek"),
              moment().endOf("isoWeek")
            ],
            "Last week": [
              moment()
                .subtract(1, "week")
                .startOf("isoWeek"),
              moment()
                .subtract(1, "week")
                .endOf("isoWeek")
            ],
            "This month": [moment().startOf("month"), moment().endOf("month")],
            "Last month": [
              moment()
                .subtract(1, "month")
                .startOf("month"),
              moment()
                .subtract(1, "month")
                .endOf("month")
            ],
            "This year": [moment().startOf("year"), moment().endOf("year")],
            "Last year": [moment().subtract(1, "year"), moment()]
          }
        }
      ],
      isBusy: false,
      sortBy: "connected_at",
      sortDesc: true,
      fields: [
        {
          key: "eid",
          label: "Id",
          sortable: false,
          class: "d-none",
          ignore: true
        },
        {
          key: "online",
          sortable: false,
          class: "",
          ignore: true
        },
        {
          key: "etenant_id",
          label: "Tenant",
          sortable: true,
          class: "",
          ignore: true
        },
        {
          key: "eshop_id",
          label: "Shop",
          sortable: true,
          class: "",
          ignore: true
        },
        {
          key: "eterminal_id",
          label: "Terminal",
          sortable: true,
          class: "",
          ignore: true
        },
        { key: "username", sortable: true, class: "" },
        { key: "session", sortable: true, class: "", ignore: true },
        { key: "ip", label: "IP", sortable: true, class: "", ignore: true },
        { key: "connected_at", sortable: true, class: "", ignore: true },
        { key: "disconnected_at", sortable: true, class: "", ignore: true },
        { key: "duration", sortable: false, class: "", ignore: true }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      copy: null,
      addLabel: "",
      selectedeid: ""
    };
  },
  methods: {
    refresh() {
      this.$root.$emit("bv::refresh::table", "user-activity-table");
    },
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        let sortBy = this.sortBy;
        if (sortBy == "etenant_id") sortBy = "tenant_id";
        if (sortBy == "eshop_id") sortBy = "shop_id";
        if (sortBy == "eterminal_id") sortBy = "terminal_id";
        paginationData.sortBy = [sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach(item => {
        if (item.type != "date" && item.selected.length && !item.postIgnore) {
          if (item.field === "terminal_id") {
            exactFields.push(
              item.selected[0] === "1" ? "!" + item.field : item.field
            );
            exactValues.push(["LOIQ6p7TaKDBIpfb-Pvm_A"]);
          } else if (
            item.field === "disconnected_at" &&
            item.selected[0] === 1
          ) {
            exactFields.push("!" + item.field);
            exactValues.push([0]);
          } else {
            exactFields.push(item.field);
            if (item.trackBy) {
              const tmp = [];
              item.selected.forEach(el => {
                tmp.push(el[item.trackBy]);
              });
              exactValues.push(tmp);
            } else {
              exactValues.push(item.selected);
            }
          }
        } else if (item.type == "date") {
          if (item.selected.startDate && item.selected.endDate) {
            paginationData.dateField = item.field;
            paginationData.dateStart = item.selected.startDate;
            paginationData.dateEnd = item.selected.endDate;
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }

      const tenantByID = this.$store.getters["cache/tenantByID"];
      const shopByID = this.$store.getters["cache/shopByID"];
      const terminalByID = this.$store.getters["cache/terminalByID"];

      Promise.all([
        this.$store.dispatch("cache/fetch", "tenants").catch(e => e),
        this.$store.dispatch("cache/fetch", "shops").catch(e => e),
        this.$store.dispatch("cache/fetch", "terminals").catch(e => e)
      ]).finally(() => {
        this.$store
          .dispatch("userActivity/fetch", paginationData)
          .then(resp => {
            this.totalRows = resp.data.total;
            resp.data.rows.forEach((item, index) => {
              if (item.etenant_id) {
                const data = tenantByID(item.etenant_id);
                if (data) {
                  item.etenant_id = {
                    to: item.etenant_id,
                    name: data.brand_name
                  };
                } else {
                  item.etenant_id = {
                    to: null,
                    name:
                      item.etenant_id === "LOIQ6p7TaKDBIpfb-Pvm_A"
                        ? "-"
                        : item.etenant_id
                  };
                }
              }

              const orig_shop_id = item.eshop_id;
              if (item.eshop_id) {
                const data = shopByID(item.eshop_id);
                if (data) {
                  item.eshop_id = {
                    to: item.eshop_id,
                    name: data.name
                  };
                } else {
                  item.eshop_id = {
                    to: null,
                    name:
                      item.eshop_id === "LOIQ6p7TaKDBIpfb-Pvm_A"
                        ? "-"
                        : item.eshop_id
                  };
                }
              }

              if (item.eterminal_id) {
                const data = terminalByID(item.eterminal_id);
                if (data && orig_shop_id) {
                  item.eterminal_id = {
                    to: orig_shop_id,
                    name: data.name
                  };
                } else {
                  item.eterminal_id = {
                    to: null,
                    name:
                      item.eterminal_id === "LOIQ6p7TaKDBIpfb-Pvm_A"
                        ? "-"
                        : item.eterminal_id
                  };
                }
              }
            });
            callback(resp.data.rows);
          })
          .catch(err => {
            this.$bvToast.toast(
              this.$t(err.message),
              errorConf(this.$t("Error"))
            );
            this.totalRows = 0;
            callback([]);
          })
          .finally(() => {
            loading.close();
          });
      });
      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    rowClicked(item, index, event) {},
    mom_unix(val) {
      return moment.unix(val / 1e9);
    },
    duration(sd, ed) {
      sd = this.mom_unix(sd);
      if (ed === 0) {
        ed = moment();
      } else {
        ed = this.mom_unix(ed);
      }
      const dr = moment.duration(ed.diff(sd));
      let ret = "";
      if (dr.days()) {
        ret = `${dr.days()}d `;
      }
      if (dr.hours()) {
        ret = ret + `${dr.hours()}h `;
      }
      if (dr.minutes()) {
        ret = ret + `${dr.minutes()} min `;
      }
      if (dr.seconds()) {
        ret = ret + `${dr.seconds()} sec `;
      }
      return ret;
    },
    redirect() {}
  }
};
</script>

<style lang="scss" scoped>
</style>


